<template>
  <v-expansion-panels v-model="openPanels" accordion multiple readonly>
    <template v-for="item in items">
      <v-expansion-panel v-show="!item.hidden" :key="'panel-' + item.slotName" class="va-expandable-input">
        <v-expansion-panel-header class="justify-space-between" :hide-actions="item.actionHidden">
          <div class="d-flex">
            <div class="va-expandable-input--title">{{ item.title }}</div>
          </div>
          <template #actions>
            <div class="d-flex align-center va-expandable-input--action__wrapper">
              <span class="va-expandable-input--action__text">{{ $t("generic.show_on_page") }}</span>
              <slot :name="`${item.slotName}-action`"></slot>
            </div>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <slot :name="`${item.slotName}-content`" :item="item"></slot>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
  </v-expansion-panels>
</template>

<script>
  export default {
    name: "VaMultipleExpandableInput",
    props: {
      items: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        openPanels: [],
      };
    },
    watch: {
      items: {
        handler(newItems) {
          const expandedPanelIndexes = newItems.reduce((acc, currValue, currIndex) => {
            if (currValue.expanded) acc.push(currIndex);

            return acc;
          }, []);

          this.openPanels = [...expandedPanelIndexes];
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../@core/preset/preset/functions.scss";
  @import "../../@core/preset/preset/typography/index.scss";
  .va-expandable-input {
    background-color: get-color("element-bg-100") !important;
    &--title {
      @include text-body-1-bold();
      color: get-color("body");
    }
    &::before {
      box-shadow: none !important;
    }
    &::after {
      border-top: none !important;

      border-bottom-width: 1px !important;
      border-bottom-style: dashed;
      border-color: red; //get-color("border");
      // border: none !important;
    }
    &--action__text {
      @include text-body-2();
      color: get-color("body");
      margin-left: 5px;
    }
    &--action__wrapper {
      gap: 12px;
    }
    &::v-deep {
      .v-expansion-panel-header {
        padding: 16px 0;
        cursor: default;
        border: none !important;
      }
      .v-expansion-panel-content__wrap {
        padding: 0 0 16px;
      }
      .v-expansion-panel-header__icon {
        align-self: center;
        margin: 0;
        .v-input--selection-controls__input {
          margin-right: 0;
        }
      }
    }
  }

  .v-application.theme--light .v-expansion-panel.v-expansion-panel--active {
    box-shadow: none !important;
  }
</style>
